module.exports = __webpack_public_path__ + "static/media/placeholder-grayB.dd8f286e.png";